import { useCallback } from "react"

/**
 * Returns a ref callback that sets fetchpriority="high" on the DOM element.
 * Needed because React 17 does not recognize fetchpriority as a valid
 * HTML attribute and strips it during SSR/hydration.
 */
export default function useFetchPriority(value = "high") {
    return useCallback((node) => {
        if (node) {
            node.setAttribute("fetchpriority", value)
        }
    }, [value])
}
